import Input from 'components/Form/Input'

import FileUploader from 'components/Uploader/CustomUploader.js'
import React, { useEffect, useRef, useState } from 'react'
// import { FaPlus } from 'react-icons/fa'
// import { MdArrowBack } from 'react-icons/md'
import { Col, Row } from 'antd'

import DeleteIcon from 'components/icons/DeleteIcon'
import FacebookLogo from 'components/icons/SocialMediaIcons/Facebook.svg'
import InstagramLogo from 'components/icons/SocialMediaIcons/Instagramicon.svg'
import LinkedInLogo from 'components/icons/SocialMediaIcons/LinkedInIcon.svg'
import TwitterLogo from 'components/icons/SocialMediaIcons/TwitterIcon.svg'
import YouTubeLogo from 'components/icons/SocialMediaIcons/Youtubeicon.svg'

import AntdAvatar from 'components/Avatar'
import PlusIcon from 'components/icons/PlusIcon'
import RichEditor from 'components/RichEditor/RoundRichText.js'
import Select, { FormItem } from 'components/Select'
import { Form } from 'components/UIComponents/FormStyles'
import FileReader from 'components/Uploader/FileReader'
import {
  createCorporate,
  getSectorMaster,
  getSingleCoporate,
  updateCorporate,
} from 'modules/Corporate/actions'
import { useDispatch } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import SuccessMessage from 'utils/SuccessMessage'
import { EmptySpan } from '../../../components/CommonStyles'
import { LabelDiv } from '../../Events/New Event/EventForm/style'
import Header from './Header/index'
import {
  AboutCompanyContainer,
  AddMoreButton,
  AddMoreText,
  BoxWithButton,
  CompanyContactDetails,
  CompanyDetails,
  CompanySocialDetails,
  Container,
  SectionName,
  SocialDetailsBox,
  Spinner,
  SubTitle,
} from './style'

function NewCorporate({
  addNewCorporate = false,
  setAddNewCorporate,
  onSetCompanyData,
}) {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const [form] = Form.useForm()
  const params = useParams()

  const [isEditing, setIsEditing] = useState(false)

  const [isDragging, setIsDragging] = useState(false)
  const [logoFile, setLogoFile] = useState(null)
  const [pocFields, setPocFields] = useState([
    { pocName: '', pocNumber: '', pocEmail: '' },
  ])
  const [aboutText, setAboutText] = useState('')
  const [instagramLink, setInstagramLink] = useState('')
  const [twitterLink, setTwitterLink] = useState('')
  const [youtubeLink, setYoutubeLink] = useState('')
  const [linkedinLink, setLinkedinLink] = useState('')
  const [facebookLink, setFacebookLink] = useState('')
  const [companyName, setCompanyName] = useState('')
  const [shortForm, setShortForm] = useState('')
  const [companySector, setCompanySector] = useState('')
  const [sectorId, setSectorId] = useState('')
  const [companyWebsite, setCompanyWebsite] = useState('')
  const [initialLoading, setInitialLoading] = useState(true)

  const [file, setFile] = useState({})
  const [fileURL, setFileURL] = useState('')
  const [lengthError, setLengthError] = useState('')
  const [sectorMaster, setSectorMaster] = useState([])

  const fileInputRef = useRef(null)

  useEffect(() => {
    if (params) {
      let path = params?.['*']
      if (path?.includes('editCorporate') && params?.corporateId) {
        setIsEditing(true)

        fetchSingleCorporate(params?.corporateId)
      } else {
        setInitialLoading(false)
      }
    }
  }, [params])

  useEffect(() => {
    fetchSectormaster('')
  }, [])

  const fetchSingleCorporate = async corporateId => {
    let responce = await dispatch(getSingleCoporate(corporateId))
    if (responce?.logo) setFile(responce?.logo)
    if (responce?.companyName) setCompanyName(responce?.companyName)
    if (responce?.shortForm) setShortForm(responce?.shortForm)
    if (responce?.description) setAboutText(responce?.description)
    if (responce?.website) setCompanyWebsite(responce?.website)
    if (responce?.sector) setCompanySector(responce?.sector)
    if (responce?.sectorId) setSectorId(responce?.sectorId)
    if (responce?.contactDetails?.length > 0)
      setPocFields(responce?.contactDetails)
    if (
      responce?.socialDetails?.some(
        item => item?.media?.toLowerCase() === 'facebook'
      )
    )
      setFacebookLink(
        responce?.socialDetails?.find(
          item => item?.media?.toLowerCase() === 'facebook'
        )?.link
      )
    if (
      responce?.socialDetails?.some(
        item => item?.media?.toLowerCase() === 'instagram'
      )
    )
      setInstagramLink(
        responce?.socialDetails?.find(
          item => item?.media?.toLowerCase() === 'instagram'
        )?.link
      )
    if (
      responce?.socialDetails?.some(
        item => item?.media?.toLowerCase() === 'linkedin'
      )
    )
      setLinkedinLink(
        responce?.socialDetails?.find(
          item => item?.media?.toLowerCase() === 'linkedin'
        )?.link
      )
    if (
      responce?.socialDetails?.some(
        item => item?.media?.toLowerCase() === 'youtube'
      )
    )
      setYoutubeLink(
        responce?.socialDetails?.find(
          item => item?.media?.toLowerCase() === 'youtube'
        )?.link
      )
    if (
      responce?.socialDetails?.some(
        item => item?.media?.toLowerCase() === 'xlink'
      )
    )
      setTwitterLink(
        responce?.socialDetails?.find(
          item => item?.media?.toLowerCase() === 'xlink'
        )?.link
      )

    setInitialLoading(false)
  }
  const fetchSectormaster = async search => {
    let responce = await dispatch(getSectorMaster(search))

    let list = [...(responce?.result || []), { name: search, id: 'OTHERS' }]

    const seen = new Set()
    const filterData = list?.filter(item => {
      const isDuplicate = seen?.has(item?.name)
      seen?.add(item?.name)
      return !isDuplicate
    })
    setSectorMaster([...filterData])
  }
  const handleDragOver = e => {
    e.preventDefault()
    setIsDragging(true)
  }

  const handleDragLeave = e => {
    e.preventDefault()
    setIsDragging(false)
  }

  const handleDrop = e => {
    e.preventDefault()
    setIsDragging(false)
    const droppedFile = e.dataTransfer.files[0]
    handleLogoFile(droppedFile)
  }

  const handleLogoFile = file => {
    if (file) {
      setLogoFile(file)
    }
  }

  const handleClick = () => {
    fileInputRef.current.click()
  }

  const handleChange = e => {
    const selectedFile = e.target.files[0]
    handleLogoFile(selectedFile)
  }

  const handleAddMorePOC = () => {
    setPocFields([...pocFields, { pocName: '', pocNumber: '', pocEmail: '' }])
  }

  const handlePOCFieldChange = (index, field, value) => {
    const newFields = [...pocFields]
    newFields[index][field] = value
    setPocFields(newFields)
  }

  const handleDeletePOC = index => {
    // Filter out the POC based on the index
    const updatedPocFields = pocFields?.filter((_, idx) => idx !== index)

    // Update the state with the new array
    setPocFields(updatedPocFields)
  }
  const handleTextChange = data => {
    setAboutText(data)
  }

  const handleTextFormat = format => {
    const textarea = document.getElementById('about-text')
    const { selectionStart, selectionEnd } = textarea
    let text = aboutText
    const selectedText = text.slice(selectionStart, selectionEnd)

    if (format === 'bold') {
      text =
        text.slice(0, selectionStart) +
        '**' +
        selectedText +
        '**' +
        text.slice(selectionEnd)
    } else if (format === 'italic') {
      text =
        text.slice(0, selectionStart) +
        '*' +
        selectedText +
        '*' +
        text.slice(selectionEnd)
    } else if (format === 'underline') {
      text =
        text.slice(0, selectionStart) +
        '__' +
        selectedText +
        '__' +
        text.slice(selectionEnd)
    }

    setAboutText(text)
  }

  const handleCompanyNameChange = e => {
    setCompanyName(e.target.value)
  }

  const handleShotFormChange = e => {
    setShortForm(e.target.value)
  }
  const handleWebsiteChange = e => {
    setCompanyWebsite(e.target.value)
  }
  const handleInstagramLinkChange = e => {
    setInstagramLink(e.target.value)
  }
  const handleTwitterLinkChange = e => {
    setTwitterLink(e.target.value)
  }

  const handleYoutubeLinkChange = e => {
    setYoutubeLink(e.target.value)
  }

  const handleLinkedinLinkChange = e => {
    setLinkedinLink(e.target.value)
  }

  const handleFacebookLinkChange = e => {
    setFacebookLink(e.target.value)
  }

  const handleSectorSelect = (data, Options) => {
    if (Options?.name) {
      setCompanySector(Options?.name)
      setSectorId(data)
    } else {
      setCompanySector(null)
      setSectorId(null)
    }
  }
  const onSubmitFormData = async () => {
    const values = await form.validateFields()

    const socialDetails = [
      { media: 'instagram', link: instagramLink },
      { media: 'xlink', link: twitterLink },
      { media: 'youtube', link: youtubeLink },
      { media: 'linkedin', link: linkedinLink },
      { media: 'facebook', link: facebookLink },
    ]
    const filteredSocialDetails = socialDetails?.filter(item => item?.link)
    const updatedPocArray = pocFields
      ?.filter(
        poc =>
          !(
            poc?.pocName === '' &&
            poc?.pocNumber === '' &&
            poc?.pocEmail === ''
          )
      )
      .map((poc, index) => {
        return {
          ...poc,
          type: index === 0 ? 'primary' : 'secondary',
        }
      })
    let payLoad = {
      companyName: companyName,
      shortForm: shortForm,
      logo: file,
      sector: companySector,
      sectorId: sectorId,
      website: companyWebsite,
      description: aboutText,
      contactDetails: updatedPocArray,
      socialDetails: filteredSocialDetails,
    }
    if (!isEditing) {
      const result = await dispatch(createCorporate(payLoad))

      if (result?.status >= 200 && result?.status <= 300) {
        SuccessMessage('Corporate Created Successfully')
        if (!addNewCorporate) {
          navigate('/corporate')
        } else {
          onSetCompanyData(result)
          setAddNewCorporate(false)
        }
      }
    } else {
      const result = await dispatch(
        updateCorporate(payLoad, params?.corporateId)
      )

      if (result?.status >= 200 && result?.status <= 300) {
        SuccessMessage('Corporate Edited Successfully')
        if (!addNewCorporate) {
          navigate('/corporate')
        }
      }
    }
  }

  return (
    <>
      <Container addNewCorporate={addNewCorporate}>
        {initialLoading && (
          <div>
            {' '}
            <Spinner></Spinner>
          </div>
        )}
        {!initialLoading && (
          <Form
            scrollToFirstError
            onFinish={onSubmitFormData}
            id={'corporatesForm'}
            form={form}
            layout="vertical"
          >
            {!addNewCorporate && <Header isEditing={isEditing} />}
            <SubTitle>Company Details </SubTitle>
            <Row gutter={40}>
              <Col md={addNewCorporate ? 24 : 12}>
                <CompanyDetails>
                  <LabelDiv>Company Logo</LabelDiv>
                  {!file?.url && (
                    <FileUploader
                      isDefault={false}
                      customUploader={true}
                      file={file}
                      setFile={setFile}
                      setFileURL={setFileURL}
                      fileURL={fileURL}
                      bgcolor={'#F9FAFE'}
                      borderColor={'#D6DBF7'}
                      format=" (.jpg, png) Max size : 2 MB"
                      message={'Invalid file uploaded'}
                      height={'165px'}
                      accept={'.jpg, .jpeg, .png,'}
                    />
                  )}
                  {file?.url && (
                    <div
                      style={{ display: addNewCorporate ? 'block' : 'flex' }}
                    >
                      <AntdAvatar
                        size={140}
                        style={{
                          verticalAlign: 'middle',
                        }}
                        font={'140px'}
                        src={file?.url}
                        shape="square"
                      ></AntdAvatar>
                      <div
                        style={{
                          margin: addNewCorporate ? '20px 0' : '80px 0 0 20px',
                        }}
                      >
                        <FileReader
                          file={file}
                          setFile={setFile}
                          progress="100"
                          // setErrorMessage={setErrorMessage}
                          handleRemoveClick={() => {
                            setFile({})
                            setFileURL('')
                          }}
                        />
                      </div>
                    </div>
                  )}
                </CompanyDetails>
              </Col>
              <Col md={addNewCorporate ? 24 : 12}>
                <CompanyDetails style={{ margintop: '10px' }}>
                  <LabelDiv>Company Name *</LabelDiv>
                  <Input
                    type="text"
                    width="100%"
                    height={'48px'}
                    padding={20}
                    rules={[
                      () => ({
                        validator(_, value) {
                          if (!companyName?.trim()) {
                            return Promise.reject(
                              new Error(`Please enter company name`)
                            )
                          }
                          return Promise.resolve()
                        },
                      }),
                    ]}
                    placeholder="Enter company name"
                    name="companyName"
                    value={companyName}
                    defaultValue={companyName}
                    onChange={handleCompanyNameChange}
                  />
                </CompanyDetails>

                <CompanyDetails>
                  <LabelDiv>Company Name (Short form)</LabelDiv>
                  <Input
                    type="text"
                    width="100%"
                    placeholder="Enter company short form name"
                    height={'48px'}
                    value={shortForm}
                    defaultValue={shortForm}
                    onChange={handleShotFormChange}
                  />
                </CompanyDetails>
              </Col>
            </Row>
            <Row gutter={40}>
              <Col
                md={addNewCorporate ? 24 : 12}
                order={addNewCorporate ? 2 : 1}
              >
                <AboutCompanyContainer>
                  <RichEditor
                    size={'small'}
                    labelName="About Company"
                    placeholder="Enter company details"
                    onChange={handleTextChange}
                    value={aboutText}
                    setLengthError={setLengthError}
                    isCompanyDescription={true}
                  />
                </AboutCompanyContainer>
              </Col>
              <Col
                md={addNewCorporate ? 24 : 12}
                order={addNewCorporate ? 2 : 1}
              >
                <FormItem>
                  <LabelDiv>Company Sector</LabelDiv>
                  <Select
                    width="auto"
                    placeholder="Select Sector Name"
                    showSearch={true}
                    allowClear={true}
                    OptionData={sectorMaster}
                    filterOption={false}
                    selectedPlaceId={'sectorId'}
                    height={'48px'}
                    listHeight={170}
                    textTransformInitial={true}
                    value={companySector}
                    onSearch={value => fetchSectormaster(value)}
                    onChange={handleSectorSelect}
                  />
                </FormItem>

                <CompanyDetails>
                  <LabelDiv>Company Website</LabelDiv>
                  <Input
                    height={'48px'}
                    width="100%"
                    type="text"
                    placeholder="Enter company website"
                    value={companyWebsite}
                    onChange={handleWebsiteChange}
                  />
                </CompanyDetails>
              </Col>
            </Row>
            <Row gutter={40}>
              <Col md={addNewCorporate ? 24 : 12}>
                <SubTitle>Company Contact Details</SubTitle>

                {pocFields.map((field, index) => (
                  <BoxWithButton key={index}>
                    <SectionName>
                      {/* <LeftSection> */}
                      <Row>
                        <Col span={index === 0 ? 24 : 22}>
                          <CompanyContactDetails>
                            <LabelDiv>
                              POC Name{' '}
                              {index === 0 ? '(Primary)' : `(${index + 1})`}
                            </LabelDiv>
                            <Input
                              width="100%"
                              height={'48px'}
                              type="text"
                              placeholder="Enter POC Name"
                              value={field.pocName}
                              onChange={e =>
                                handlePOCFieldChange(
                                  index,
                                  'pocName',
                                  e.target.value
                                )
                              }
                            />
                          </CompanyContactDetails>
                          <CompanyContactDetails>
                            <LabelDiv>
                              POC Number{' '}
                              {index === 0 ? '(Primary)' : `(${index + 1})`}
                            </LabelDiv>
                            <Input
                              type="text"
                              width="100%"
                              placeholder="Enter POC Number"
                              height={'48px'}
                              value={field.pocNumber}
                              maxLength={10}
                              onChange={e => {
                                const value = e.target.value

                                // Allow only numbers
                                const numericValue = value?.replace(/\D/g, '')

                                handlePOCFieldChange(
                                  index,
                                  'pocNumber',
                                  numericValue
                                )
                              }}
                            />
                          </CompanyContactDetails>
                          <CompanyContactDetails
                            bottomSpace={index === pocFields.length - 1}
                          >
                            <LabelDiv>
                              POC Email{' '}
                              {index === 0 ? '(Primary)' : `(${index + 1})`}
                            </LabelDiv>
                            <Input
                              type="email"
                              width="100%"
                              height={'48px'}
                              placeholder="Enter POC Email"
                              value={field.pocEmail}
                              onChange={e =>
                                handlePOCFieldChange(
                                  index,
                                  'pocEmail',
                                  e.target.value
                                )
                              }
                            />
                          </CompanyContactDetails>
                        </Col>
                        {index != 0 && (
                          <Col
                            span={2}
                            style={{
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                            }}
                          >
                            <EmptySpan onClick={() => handleDeletePOC(index)}>
                              <DeleteIcon />
                            </EmptySpan>
                          </Col>
                        )}
                      </Row>
                    </SectionName>
                    {index === pocFields.length - 1 &&
                      pocFields.length <= 9 && (
                        <AddMoreButton onClick={handleAddMorePOC}>
                          <AddMoreText>
                            {' '}
                            <PlusIcon color="#3249D7" /> &nbsp;{' '}
                            <span style={{ paddingTop: '1px' }}>Add More</span>
                          </AddMoreText>
                        </AddMoreButton>
                      )}
                  </BoxWithButton>
                ))}
              </Col>
              <Col md={addNewCorporate ? 24 : 12}>
                <CompanySocialDetails>
                  <SubTitle>Company Social Details</SubTitle>
                  <SectionName>
                    <SocialDetailsBox>
                      <img src={InstagramLogo} alt="Instagram Logo" />
                      <Input
                        type="text"
                        padding={8}
                        width="100%"
                        height={'48px'}
                        placeholder="Enter Instagram Link"
                        value={instagramLink}
                        onChange={handleInstagramLinkChange}
                      />
                    </SocialDetailsBox>
                    <SocialDetailsBox>
                      <div>
                        <img src={TwitterLogo} alt=" Twitter Logo" />
                        <Input
                          type="text"
                          placeholder="Enter X link(formerly known as twitter)"
                          value={twitterLink}
                          onChange={handleTwitterLinkChange}
                          width="100%"
                          height={'48px'}
                        />
                      </div>
                    </SocialDetailsBox>
                    <SocialDetailsBox>
                      <div>
                        <img src={YouTubeLogo} alt="Youtube Logo" />
                        <Input
                          type="text"
                          placeholder="Enter Youtube Link"
                          value={youtubeLink}
                          onChange={handleYoutubeLinkChange}
                          width="100%"
                          height={'48px'}
                        />
                      </div>
                    </SocialDetailsBox>
                    <SocialDetailsBox>
                      <div>
                        <img src={LinkedInLogo} alt="Linkedin Logo" />
                        <Input
                          type="text"
                          placeholder="Enter Linkedin Link"
                          value={linkedinLink}
                          onChange={handleLinkedinLinkChange}
                          width="100%"
                          height={'48px'}
                        />
                      </div>
                    </SocialDetailsBox>
                    <SocialDetailsBox>
                      <div>
                        <img src={FacebookLogo} alt="FacebookLogo" />
                        <Input
                          type="text"
                          placeholder="Enter Facebook Link"
                          value={facebookLink}
                          onChange={handleFacebookLinkChange}
                          width="100%"
                          height={'48px'}
                        />
                      </div>
                    </SocialDetailsBox>
                  </SectionName>
                </CompanySocialDetails>
              </Col>
            </Row>
          </Form>
        )}
      </Container>
    </>
  )
}

export default NewCorporate
